<template>
  <div>
    <b-container fluid class="px-2">
      <b-row class="">
        <b-col cols="12" md="4" class="">
          <h6 class="text-primary font-weight-bold mb-2">
            Добавить меню
          </h6>
          <div class="card card-body">
            <!-- Menu Create Title -->
            <b-form-group
              label="Название меню"
              label-for="menuCreateTitle"
            >
              <b-form-input
                id="menuCreateTitle"
                placeholder="Название меню"
              />
            </b-form-group>

            <!-- Menu Create Link -->
            <b-form-group
              label="Ссылка"
              label-for="menuCreateLink"
            >
              <b-form-input
                id="menuCreateLink"
                placeholder="Ссылка"
              />
            </b-form-group>

            <!-- In New Tab -->
            <b-form-group>
              <b-form-checkbox
                value="A"
              >
                Открыть ссылку в новой вкладке
              </b-form-checkbox>
            </b-form-group>
            <!-- Button -->
            <b-form-group class="d-flex justify-content-center mt-1">

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2" >
                Сохранить
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="light"
              >
                Очистить
              </b-button>

            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" lg="8" md="8">
          <h6 class="text-primary font-weight-bold mb-2">
            Список меню
          </h6>
          <div class="card card-body">
            <app-collapse
              type="default"
              class="collapse-menu cursor-move"
            >
              <!-- draggable -->
              <draggable
                v-model="MenuItems"
              >
                  <app-collapse-item
                    v-for="(item, index) in MenuItems"
                    :key="index"
                    :data="index"
                    :title="item.name"
                    class="cursor-move"
                  >

                    <b-row class="">
                      <b-col cols="12" lg="6" md="6" class="">

                        <!-- Menu Title -->
                        <b-form-group
                          label="Название меню"
                          label-for="menuTitle"
                        >
                          <b-form-input
                            id="menuTitle"
                            placeholder="Название меню"
                            :value="item.name"
                          />
                        </b-form-group>

                      </b-col>
                      <b-col cols="12" lg="6" md="6" class="">

                        <!-- Menu Link -->
                        <b-form-group
                          label="Ссылка"
                          label-for="menuLink"
                        >
                          <b-form-input
                            id="menuLink"
                            placeholder="Ссылка"
                            :value="item.href"
                          />
                        </b-form-group>

                      </b-col>

                      <!-- In New Tab -->
                      <b-col cols="12">
                        <b-form-group>
                          <b-form-checkbox
                            :checked="item.new_tab ? true : false"
                          >
                            Открыть ссылку в новой вкладке
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <!-- Button -->
                      <b-col cols="12">
                        <b-form-group class="d-flex justify-content-end mt-1">
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="light"
                            class="mr-2"
                          >
                            Удалить
                          </b-button>

                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                          >
                            Сохранить
                          </b-button>
                        </b-form-group>
                      </b-col>

                    </b-row>

                  </app-collapse-item>
              </draggable>
            </app-collapse>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
    AppCollapse,
    AppCollapseItem,
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
  },
  data() {
    return {
      MenuItems: [],
      url: '',
    }
  },
  methods: {
    readItemsMenu() {
      const that = this
      that.$http.get(`${this.url}/api/menus`, {}, {})
        .then(response => {
          that.MenuItems = response.data
        }).catch()
    },
  },
  created() {
    this.url = 'https://tojtel.tj'
    this.readItemsMenu()
  },
}
</script>

<style scoped>
.collapse-menu .card {
  box-shadow: none !important;
}
</style>
